import { IPaginationStore, IPaginationStoreAction, PaginationActionTypes, PaginationDispatcher } from './types';

export const setDispatch = (dispatch: PaginationDispatcher): IPaginationStoreAction<PaginationActionTypes, Partial<IPaginationStore>> => ({
  type: PaginationActionTypes.SET_DISPATCH,
  payload: {
    dispatch,
  },
});

export const setShowAll = (showAll: boolean): IPaginationStoreAction<PaginationActionTypes, Partial<IPaginationStore>> => ({
  type: PaginationActionTypes.SET_SHOW_ALL,
  payload: {
    showAll,
  },
});

export const toggleShowAll = (): IPaginationStoreAction<PaginationActionTypes, Partial<IPaginationStore>> => ({
  type: PaginationActionTypes.TOGGLE_SHOW_ALL,
  payload: {},
});
